import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/product/EprAggregateRecordWorkspaceQuery.graphql';
import fragment from '../../fragments/product/EprAggregateRecordFragment.graphql';

const EprAggregateRecord: EntityType = {
  type: 'EprAggregateRecord',
  title: 'EPR Aggregate Records',
  workspaceUrl: '/Products/EPR/EprAggregateRecord/Workspace/',
  workspace: workspaceQuery,
  fragment: fragment,
  screenReference: 'EPR_AGGREGATE_RECORD',
};

export default EprAggregateRecord;
